module.exports = __webpack_public_path__ + "static/media/TH8.5e494a13.jpg";